import {
  DocumentUploaded,
  ExposedDocumentation,
  DocumentId,
  DocumentationId,
  UserId,
  CreditStudyId,
  DocumentsCompleted,
} from './../../../domain';
import { ExposedDocumentationDto, Documents } from './../dtos';

export const mapExposedDocumentationDtoToDomain = (
  exposedDocumentationDto: ExposedDocumentationDto
): ExposedDocumentation => {
  return {
    id: new DocumentationId(exposedDocumentationDto.id),
    userId: new UserId(exposedDocumentationDto.userId),
    creditStudyId: new CreditStudyId(exposedDocumentationDto.creditStudyId),
    isComplete: new DocumentsCompleted(exposedDocumentationDto.isComplete),
    type: exposedDocumentationDto.type,
    status: exposedDocumentationDto.status,
    requiredDocuments: exposedDocumentationDto.requiredDocuments,
    documents: mapDocument(exposedDocumentationDto.documents),
  };
};

const mapDocument = (documents: Documents[]): DocumentUploaded[] => {
  return documents.map((document) => {
    return new DocumentUploaded(new DocumentId(document.id), new DocumentId(document.documentationId), document.type);
  });
};
